import * as Sentry from '@sentry/react'
import { useEffect, useMemo } from 'react'
import { selectAccountId } from '../../../../store/auth/authSlice'
import { useAppSelector } from '../../../../store/hooks'
import { useListTemplatesQuery } from '../../../../store/templateLibrary/templateLibrary'
import { SCHEDULING_EMAIL_TEMPLATE_TYPE } from '../TemplatesTab'
import { readSchedulingEmails } from './schedulingEmails'

interface UseSchedulingEmailsOptions {
  skip?: boolean
  refetchOnMountOrArgChange?: number
}

export const useSchedulingEmails = ({ skip = false, refetchOnMountOrArgChange }: UseSchedulingEmailsOptions = {}) => {
  const accountId = useAppSelector(selectAccountId)
  const { data, isLoading, isError, refetch } = useListTemplatesQuery(
    { accountId, type: SCHEDULING_EMAIL_TEMPLATE_TYPE, scopes: ['system', 'account', 'enterprise'] },
    { skip, refetchOnMountOrArgChange },
  )
  const { emails, missingDefaultSlugs } = useMemo(() => readSchedulingEmails(data?.data ?? []), [data])
  const isLoaded = data != null

  useEffect(() => {
    if (!isLoaded) {
      return
    }
    missingDefaultSlugs.forEach((slug) => Sentry.captureMessage('Scheduling email has no Zocks default', { extra: { slug } }))
  }, [isLoaded, missingDefaultSlugs])

  return { emails, templates: data?.data, isLoading, isError, refetch }
}
